import { daysAgo } from '../../../helpers';
import { useGetCreditCardDashboardData } from '../../useGetCreditCardDashboardData';

export const useGetRecentlyReplacedCard = (): {
    orderedDate: Date;
    reason: 'damaged' | 'lost_or_stolen';
} | null => {
    const { cards, activeCard } = useGetCreditCardDashboardData();

    const recentlyDamagedCards =
        activeCard?.plastics
            ?.filter(
                (p) =>
                    (p.status === 'ACTIVE' || p.status === 'INACTIVE') &&
                    p.production_type === 'NEW_PLASTIC' &&
                    p.created_date &&
                    new Date(p.created_date) > daysAgo(7)
            )
            .map((p) => ({
                orderedDate: new Date(p.created_date),
                reason: 'damaged' as const
            })) ?? [];

    const recentlyLostStolenCards = cards!
        .filter(
            (c) =>
                c.status === 'lost_or_stolen' &&
                new Date(c.status_date) > daysAgo(7)
        )
        .map((c) => ({
            orderedDate: new Date(c.status_date),
            reason: 'lost_or_stolen' as const
        }));

    const recentlyReplacedCards = [
        ...recentlyDamagedCards,
        ...recentlyLostStolenCards
    ];

    if (recentlyReplacedCards.length === 0) {
        return null;
    }

    return recentlyReplacedCards.sort(
        (a, b) => b.orderedDate.getTime() - a.orderedDate.getTime()
    )[0];
};
